import React, { useEffect, useMemo, useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';

import { getIssuers } from '../../Utils/backStageApi';
import { IssuerItem, IssuerTable } from '../../Components/Issuer/IssuerTable';
import { IssuerActionBar } from '../../Components/Issuer/IssuerActionBar';

const IssuerManagerPage: React.FC = () => {
  const history = useHistory();
  const [issuers, setIssuers] = useState<IssuerItem[]>([]);
  const [searchText, setSearchText] = useState<string>('');

  useEffect(() => {
    getIssuers().then((data) => {
      if (!data?.list) return;
      setIssuers(data.list);
    });
  }, []);

  const filtered = useMemo(
    () =>
      issuers.filter((i) => {
        const q = searchText.trim();
        if (!q) return true;
        return i.name.includes(q) || i.id.toLowerCase().includes(q.toLowerCase()) || i.ips.some((ip) => ip.includes(q));
      }),
    [issuers, searchText],
  );

  const handleEdit = (issuer: IssuerItem) => {
    history.push('/bs/issuer/edit', { issuer });
  };

  return (
    <Flex w="100%" direction="column" align="center" pt="50px" pb="100px">
      <Text
        fontFamily="'Open Sans', sans-serif"
        fontSize="30px"
        fontWeight={600}
        lineHeight="133%"
        letterSpacing="0.01em"
        color="#000000"
        textAlign="center"
      >
        機構管理
      </Text>

      <IssuerActionBar
        mt="50px"
        searchText={searchText}
        onSearchChange={setSearchText}
        onAdd={() => history.push('/bs/issuer/create')}
      />

      <IssuerTable mt="22px" issuers={filtered} onEdit={handleEdit} />
    </Flex>
  );
};

export default IssuerManagerPage;
